'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroSingleSelect = require('./NitroSingleSelect');

var _NitroSingleSelect2 = _interopRequireDefault(_NitroSingleSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroSingleSelect2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-single-select/index.js
// module id = 60
// module chunks = 4